import { useEffect, useState } from 'react'

import { useServerTimeOffsetMs } from '~/hooks/useServerTimeOffsetMs'
import { now as serverNow } from '~/models/clock'
import { isTargetDateTodayInJst, toProtoDate } from '~/models/dateTime'
import type { GateCloseFrontier } from '~/models/gateClose'
import { advanceGateCloseFrontier } from '~/models/gateClose'
import { formatGcRemainingTime } from '~/models/gcRemainingTime'

/** 残り10分以内で強調表示 (AC-BDB-027)。 */
const URGENT_THRESHOLD_SEC = 10 * 60

export type GcCountdown = {
  text: string
  isUrgent: boolean
}

/** 当日だけ表示する (AC-BDB-022)。締切はbackend snapshotを共有moduleで進める。 */
export function useGcCountdown(
  frontier: GateCloseFrontier | undefined,
  displayDate: Date,
): GcCountdown | null {
  const offsetMs = useServerTimeOffsetMs()
  const [now, setNow] = useState(() => serverNow())

  useEffect(() => {
    setNow(serverNow())
    const id = setInterval(() => setNow(serverNow()), 1000)
    return () => clearInterval(id)
  }, [offsetMs])

  if (
    frontier === undefined ||
    !isTargetDateTodayInJst(toProtoDate(displayDate), now)
  )
    return null

  const current = advanceGateCloseFrontier(frontier, now)
  const diffSec = Math.floor(
    (current.nextCloseAt.getTime() - now.getTime()) / 1000,
  )
  return {
    text: formatGcRemainingTime(diffSec),
    isUrgent: diffSec <= URGENT_THRESHOLD_SEC,
  }
}
